/**
 * Локальное дублирование факта просмотра новостей.
 * Источник истины — сервер: /api/news/feed/ не отдаёт уже просмотренные.
 * localStorage нужен только чтобы модалка не мигала до ответа сервера.
 */

const KEY = 'client_news_seen_v1';
const KEEP_LAST = 100;

export const getSeenNews = () => {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
};

export const getSeenNewsIds = () => getSeenNews().map(r => r?.news_id).filter(Boolean);

export const isNewsSeen = (newsId) => getSeenNewsIds().includes(newsId);

export const markNewsSeen = (newsId) => {
    if (!newsId) return;
    try {
        const list = getSeenNews().filter(r => r?.news_id !== newsId);
        list.push({ news_id: newsId, completed_at: new Date().toISOString() });
        localStorage.setItem(KEY, JSON.stringify(list.slice(-KEEP_LAST)));
    } catch (e) {
        // приватный режим / переполнение — не критично, сервер всё помнит
    }
};

export const clearSeenNews = () => {
    try { localStorage.removeItem(KEY); } catch (e) {}
};

/** 'mobile' | 'desktop' — уходит в статистику вместе с событиями просмотра */
export const getDeviceType = () => {
    if (typeof window === 'undefined') return 'desktop';
    const ua = (navigator.userAgent || '').toLowerCase();
    const isTouch = window.matchMedia?.('(pointer: coarse)')?.matches;
    if (/iphone|ipod|ipad|android|mobile/.test(ua) || (isTouch && window.innerWidth < 900)) {
        return 'mobile';
    }
    return 'desktop';
};